import { Layout, Menu } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';

import { menus } from '../../routes/menus';
import { AuthConsumer } from '../../security/authContext';
import Brand from '../Brand';
import ItemMenu from './ItemMenu';
import { ContainerBrand, DividerMenu } from './styles';
import SubMenuItem from './SubMenuItem';

const { Sider } = Layout;

const SideBar = ({ isCollapsed }) => {
  const [collapsed, setCollapsed] = useState(isCollapsed);
  const [active, setActive] = useState('1');
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const history = useHistory();

  useEffect(() => {
    const ativo = menus().filter(
      menu =>
        menu.url === history.location.pathname ||
        history.location.pathname.startsWith(menu.url)
    );
    if (ativo[0]) {
      setActive(ativo[0].id.toString());
    }
  }, [history.location.pathname]);

  const onClickMenu = menu => {
    setActive(menu.id.toString());
    if (menu.url && history.location.pathname !== menu.url) {
      history.push(menu.url);
    }
  };

  return (
    <Sider
      collapsible={!isTabletOrMobile}
      collapsed={isTabletOrMobile || collapsed}
      onCollapse={setCollapsed}
    >
      <ContainerBrand>
        <Brand
          type="sidebar"
          size="lg"
          isCollapsed={isTabletOrMobile || collapsed}
        />
      </ContainerBrand>

      <DividerMenu
        iscollapsed={isTabletOrMobile ? 'true' : collapsed.toString()}
      />

      <AuthConsumer>
        {({ user }) => (
          <Menu
            defaultOpenKeys={['sub1']}
            selectedKeys={[active]}
            mode="inline"
            theme="dark"
          >
            {menus().map(menu => {
              if (menu.menus && menu.menus.length > 0) {
                return (
                  <SubMenuItem
                    menu={menu}
                    user={user}
                    key={menu.id}
                    onClickMenu={onClickMenu}
                    isTabletOrMobile={isTabletOrMobile}
                    collapsed={collapsed}
                  />
                );
              }
              return (
                <ItemMenu
                  menu={menu}
                  user={user}
                  key={menu.id}
                  onClickMenu={onClickMenu}
                  isTabletOrMobile={isTabletOrMobile}
                  collapsed={collapsed}
                />
              );
            })}
          </Menu>
        )}
      </AuthConsumer>
    </Sider>
  );
};

SideBar.propTypes = {
  isCollapsed: PropTypes.bool,
};

SideBar.defaultProps = {
  isCollapsed: false,
};

export default SideBar;
